import { slider } from 'vue-concise-slider'
export default {
  name: 'mslider',
  mixins: [ slider ],
  methods: {
    swipeStart (e) {
        let that = this
        this.s_data.e = e
        if (this.s_data.freeze) {
          return
        }
        if (this.s_data.transitionEnding) {
          return
        }
        if (this.s_data.transitionEnding) {
          return
        }
        if (this.s_data.itemTransitionEnding && this.options.itemAnimation) {
          return
        }
        this.s_data.animation = false
        // 暂停自动滚动
        if (this.options.autoplay) {
          this.clock().stop(that)
        }
        this.$emit('swipestart')
        // 阻止页面滚动
        if (this.options.preventDocumentMove === true) {
          document.addEventListener('touchmove', that.preventDefault(e))
        }
        if (e.type === 'touchstart') {
          if (e.touches.length > 1) {
            this.s_data.tracking = false
            return false
          } else {
            this.s_data.tracking = true
            /* Hack - would normally use e.timeStamp but it's whack in Fx/Android */
            this.data.start.t = new Date().getTime()
            this.data.start.x = e.targetTouches[0].clientX
            this.data.start.y = e.targetTouches[0].clientY
            this.data.end.x = e.targetTouches[0].clientX
            this.data.end.y = e.targetTouches[0].clientY
          }
        } else {
          this.s_data.tracking = true
          /* Hack - would normally use e.timeStamp but it's whack in Fx/Android */
          this.data.start.t = new Date().getTime()
          this.data.start.x = e.clientX
          this.data.start.y = e.clientY
          this.data.end.x = e.clientX
          this.data.end.y = e.clientY
        }
    },
    slide (pagenum, type) {
      // 执行动画
      this.s_data.animation = true
      // 处理点击事件
      if (type === 'slideTo' && this.s_data.onSlide === true) {
        return false
      }
      if ((pagenum || pagenum === 0) && type === undefined) {
        this.data.direction = 'rebound'
      }
      // 无样式滚动
      if (type === 'animationnone') {
        this.s_data.animation = false
        this.s_data.onSlideEnd = true
        this.s_data.onSlide = false
      } else {
        this.s_data.onSlideEnd = false
        this.s_data.onSlide = true
      }
      if (pagenum || pagenum === 0) {
        this.data.currentPage = pagenum
      }
      // 传递事件
      if (type !== 'click') {
        this.$emit('slide', this.data)
      } else {
        this.$emit('mclick', this.data)
      }
      // fade优化
      if (this.s_data.effect === 'fade') {
        if (!this.pagenums) {
          this.fadeDom()
        }
        return
      } else {
        // 增加垂直滚动判定
        if (this.options.direction === 'vertical') {
          if (Math.abs(this.data.posheight) === Math.abs(-this.currentHeight)) {
            this.s_data.onSlideEnd = true
            this.s_data.onSlide = false
          }
          this.data.posheight = -this.currentHeight
        } else {
          if (Math.abs(this.data.poswidth) === Math.abs(-this.currentWidth)) {
            this.s_data.onSlideEnd = true
            this.s_data.onSlide = false
          }
          this.data.poswidth = -this.currentWidth
        }
      }
      // 添加class
      if (this.s_data.sliderLength) {
        let slideDom = this.$el.getElementsByClassName('slider-wrapper')[0]
        let childrens = Array.prototype.slice.call(slideDom.children)
        let sliderItem = childrens.filter((item) => {
          return item.className.indexOf('slider-item') !== -1
        })
        let sliderActiveCopy = childrens.filter((item) => {
          return item.className.indexOf('slider-active-copy') !== -1
        })
        // let sliderItem = slideDom.getElementsByClassName('slider-item')
        // let sliderActiveCopy = slideDom.getElementsByClassName('slider-active-copy')
        let loopedSlides = this.options.loopedSlides || 1
        let sliderLength = this.s_data.sliderLength
        let children = this.$children
        let currentPage = this.data.currentPage
        children = children.filter((item) => {
          return item.$options.name === 'slideritem'
        })
        children.forEach(element => {
          element.removeActive()
        })
        // 取消嵌套轮播active标签
        if (this.options.effect === 'nest') {
          return
        }
        if (children[currentPage]) {
          children[currentPage].addActive()
        }
        if (currentPage < 0 || currentPage >= (this.pagenums || sliderLength)) {
          if (sliderItem[currentPage + loopedSlides] && sliderItem[currentPage + loopedSlides].classList) {
            sliderItem[currentPage + loopedSlides].classList.add('slider-active-copy')
          }
          let lastPage = currentPage < 0 ? (this.pagenums || sliderLength) + currentPage : 0 + currentPage - (this.pagenums || sliderLength)
          children[lastPage] && children[lastPage].addActive()
        } else {
          for (let index = 0; index < sliderActiveCopy.length; index++) {
            const item = sliderActiveCopy[index]
            item.classList.remove('slider-active-copy')
          }
        }
      }
      if (this.data.currentPage < 0 || this.data.currentPage >= (this.pagenums || this.s_data.sliderLength)) {
        return false
      }
    }
  }
}